/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './animation030.less';
import ImgPoint from '../../../../../assets/animation_point.gif';

interface IAnimation030Item {
  text: string;
}

interface IAnimation030Props {
  items: IAnimation030Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation030: React.FunctionComponent<IAnimation030Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 2) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation030 component ${className || ''}`}>
      <img
        className="click-point"
        onClick={() => clickToPlay()}
        style={{
          display: play <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      {items.map((itm: IAnimation030Item, idx: number) => (
        <div key={idx} className="animation030-contaner">
          <div
            className={`animation030-item r${idx + 1} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <div className="out-circle">
              <div className="indicator">0{idx + 1}</div>
              <div
                className="text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation030;
